import React from "react";
import "./timeline.css";
import { BiCheck } from "react-icons/bi";

function Timeline({ item, status }) {
  return (
    <div className="relative">
      <div className="column-right ">
        <div className="col-card-right">
          <div className="col-card-title col-card-title-right">
            {item.status || item.label}
          </div>
          <div className="col-card-subtitle col-card-subttitle-right">
            {item.location}
          </div>
        </div>
        <div className="col-card-right"></div>
      </div>

      <div className="column-left">
        <div className="col-note col-note-left">
          <p>{item.time || item.date}</p>
        </div>
      </div>

      <div className="column-center">
        <div className="line"></div>
        <div
          className="circle"
          style={{ background: status ? "#16AC37" : "#fff" }}
        >
          {status && <BiCheck className="-ml-[2px] -mt-0.5 text-white" />}
        </div>
      </div>

      <div className="clearfix"></div>
    </div>
  );
}

export default Timeline;
